import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import Header from '../Layout/Header';

class Message extends Component {

	render() {
		return <div>
			<Header />

			<div className="frontpage-container message">

				<Card className={this.props.errorMessage !== undefined ? "error-card" : "message-card"}>
					<Card.Body>
						<Card.Title className="">Bince App</Card.Title>

						<p> {this.props.errorMessage !== undefined ? this.props.errorMessage : this.props.successMessage}</p>

					</Card.Body>
				</Card>
			</div>
		</div>
	}
}

export default Message;


// WEBPACK FOOTER //
// ./src/components/FrontPage/Message.js